import url_ from "asset-data:assets/galleries/featured/window_19b02596ea__400.jpg";
export const url = url_;